<template>
  <div class="h-1 w-48 bg-gray-100">
    <div :style="`width: ${percentage}%;`" class="h-1 w-48 bg-blue-500"></div>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
  },
  setup(props) {
    const percentage = computed(() => Math.max(0, Math.min(100, Number(props.value))))
    return { percentage }
  },
}
</script>
